import { Tooltip } from '@material-ui/core'
import Switch from '@mui/material/Switch'
import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Button,
  Copy
} from 'components'
import { StatusIcon, MagnifyingGlassIcon } from 'components/Icons'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { IPendingCreSearch } from 'services/NGT/PendingCre'
import { COLORS, FORMAT } from 'utils'

interface ITablePendingCre {
  tableData: IPendingCreSearch[]
  page: number
  setPage: (page: number) => void
  setRowsPerPage: (rowsPerPage: number) => void
  selectedContractInfo: (contractId: number) => void
  rowsPerPage: number
  totalItems: number
  areDatesValid: () => boolean
  dateErrors?: any
}
export const TablePendingCre = ({
  dateErrors,
  tableData,
  areDatesValid,
  setRowsPerPage,
  setPage,
  page,
  rowsPerPage,
  totalItems,
  selectedContractInfo
}: ITablePendingCre) => {
  const handleChangePage = (newPage: number) => setPage(newPage)
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(1)
  }

  const handleStatus = (status: string) => {
    if (
      status === 'Green' ||
      status === 'Aprovado' ||
      status === 'Liberado' ||
      status === 'L'
    )
      return 'Documentos analisados'
    if (
      status === 'Yellow' ||
      status === 'Analisar' ||
      status === 'Analisando' ||
      status === 'PendenteDocumento' ||
      status === 'P'
    )
      return 'Documentos em processo de Análise'
    if (status === 'Red' || status === 'Recusado' || status === 'B')
      return 'Documentos não analisados no prazo (Backlog)'
    return 'Documentos não analisados no sistema'
  }

  const { push } = useHistory()

  const handleRedirecionar = (row: IPendingCreSearch) => {
    if (!row.flEmAnalise) {
      push({
        pathname: '/ngt/analise-cre',
        state: {
          cdContrato: row.cdContrato,
          dtCompetencia: row.nuAnoMesCompetencia,
          idCreExist: row.idCre,
          pathBack: '/ngt/analise-pendencia-cre',
          tab: 0
        }
      })
    }
  }

  const INVALID_DATE = '01/01/0001'
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left"></TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled align="left" minwidth="130px">
                Fornecedor
              </TableCellStyled>
              <TableCellStyled align="left">Competência</TableCellStyled>
              <TableCellStyled align="left">Tipo Documento</TableCellStyled>
              <TableCellStyled align="left">Bloqueio</TableCellStyled>
              <TableCellStyled align="left">Subcont.</TableCellStyled>
              <TableCellStyled align="left">Nº CRE</TableCellStyled>
              <TableCellStyled align="left">Analista</TableCellStyled>
              <TableCellStyled align="left">Data Anexo</TableCellStyled>
              <TableCellStyled align="left">Data Análise</TableCellStyled>
              <TableCellStyled align="left">Últ. Análise</TableCellStyled>
              <TableCellStyled align="left">SLA</TableCellStyled>
              <TableCellStyled align="left">Status</TableCellStyled>
              <TableCellStyled align="left">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData.length > 0 &&
              tableData.map((row, index) => (
                <TableRowStyled key={`${index}-${row.movimentacaoId}`}>
                  <TableCellStyled align="center">
                    <Copy
                      valueToCopy={row.cdContrato}
                      title="Copiar código de contrato"
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Button
                      text={row.cdContrato}
                      textColor={COLORS.blueFonts}
                      variantButton="text"
                      onClick={() => selectedContractInfo(row.contratoId)}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.nmFornecedor}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {moment(row.nuAnoMesCompetencia).format('MM/YYYY')}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.txDescDoc}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Switch checked={row.flCreBloqueado} />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Switch checked={row.flSubContrato} />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.cdCodigoCre || '---'}
                  </TableCellStyled>
                  <TableCellStyled>{row.nmAnalista}</TableCellStyled>
                  <TableCellStyled align="left">
                    {row.dtAnexado &&
                    FORMAT.formatDDMMYYYY(row.dtAnexado) !== INVALID_DATE
                      ? FORMAT.formatDDMMYYYY(row.dtAnexado)
                      : '---'}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.dtAnalise &&
                    FORMAT.formatDDMMYYYY(row.dtAnalise) !== INVALID_DATE
                      ? FORMAT.formatDDMMYYYY(row.dtAnalise)
                      : '---'}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.dtUltimaAnalise &&
                    FORMAT.formatDDMMYYYY(row.dtUltimaAnalise) !== INVALID_DATE
                      ? FORMAT.formatDDMMYYYY(row.dtUltimaAnalise)
                      : '---'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.vlSla === null ? '---' : row.vlSla}
                  </TableCellStyled>
                  <Tooltip
                    arrow
                    placement="left"
                    title={handleStatus(row.txStatusColor)}
                  >
                    <TableCellStyled align="center">
                      <StatusIcon value={row.txStatusColor} marginLeft="20px" />
                    </TableCellStyled>
                  </Tooltip>
                  <TableCellStyled
                    align="center"
                    onClick={() => {
                      handleRedirecionar(row)
                    }}
                  >
                    <MagnifyingGlassIcon style={{ justifyContent: 'center' }} />
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      {dateErrors === null && (
        <TableFooter
          page={page}
          rows={tableData}
          disabled={!areDatesValid()}
          totalItems={totalItems}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
    </>
  )
}
